export default __webpack_public_path__ + "static/media/forbes30.067d6b73.svg";